import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { Amplify } from "aws-amplify";
import { domAnimation, LazyMotion } from "motion/react";
import { Suspense } from "react";
import { Provider } from "react-redux";

import PosthogProvider from "@/monitoring/posthog";
import Authenticator from "@/shared/components/Authenticator";
import LoadingSpinner from "@/shared/components/LoadingSpinner";
import ErrorBoundary from "@/shared/components/route-state/ErrorBoundary";
import Toaster from "@/shared/components/Toaster";

import awsConfig from "../aws/awsConfig";
import { LinguiProvider } from "../i18n";
import store from "../redux/store";

Amplify.configure(awsConfig);

export interface RootRouteContext {
  permissions: string | undefined;
}

function RootComponent() {
  return (
    <Provider store={store}>
      <PosthogProvider>
        <LinguiProvider>
          <LazyMotion features={domAnimation} strict>
            <Authenticator>
              <Suspense fallback={<LoadingSpinner className="!animate-none" />}>
                <Outlet />
              </Suspense>
            </Authenticator>
            <Toaster />
          </LazyMotion>
        </LinguiProvider>
      </PosthogProvider>
    </Provider>
  );
}

export const Route = createRootRouteWithContext<RootRouteContext>()({
  component: RootComponent,
  errorComponent: ErrorBoundary,
});
